import { useSelector } from 'react-redux'
import Dialog from '../../atoms/feedback/Dialog'
import { FlexColumn } from '../../atoms/layout/Flex'
import ChatPanel from '../chat/ChatPanel'
import { MoneyspacesSelectors } from '../../../store/moneyspaces/selectors'

type Props = {
  moneyspaceId: string | null
  onClose: () => void
}

export default function ClientMoneyspaceChatDialog({ moneyspaceId, onClose }: Props) {
  const moneyspaces = useSelector(MoneyspacesSelectors.moneyspaces)
  const moneyspace = moneyspaces.find((m) => m.id === moneyspaceId)

  if (!moneyspace) {
    return null
  }

  return (
    <Dialog open={moneyspaceId !== null} onClose={onClose} title={moneyspace.name}>
      <FlexColumn>
        <ChatPanel moneyspaceId={moneyspace.id} />
      </FlexColumn>
    </Dialog>
  )
}
